<template>
    <div>
        <b-form-file
                v-model="files"
                directory
                multiple
                no-traverse
                size="sm"
                placeholder="Choose a directory or drop it here..."
                drop-placeholder="Drop file here..."
                accept="image/jpeg, audio/mpeg"
                :disabled="isUploading"
        ></b-form-file>

        <b-button-group class="my-3">
            <b-button @click="upload" :disabled="!files.length || isUploading" size="sm" variant="outline-secondary">Upload</b-button>
            <b-button v-if="dirFiles.length" @click="clear" size="sm" variant="outline-secondary">Clear</b-button>
        </b-button-group>

        <b-list-group>
                <b-list-group-item v-for="(upload, index) in uploads" :key="index">
                    <b-row>
                        <b-col>
                            <span>{{ index }}</span>
                        </b-col>

                        <b-col align="right">
                            <b-spinner v-if="upload.status === 'busy'" small></b-spinner>
                            <div v-else-if="upload.status === 'error'">
                                <small class="mr-2">{{ upload.msg }}</small>
                                <b-icon-exclamation-circle-fill variant="danger"></b-icon-exclamation-circle-fill>
                            </div>

                            <div v-else-if="upload.status === 'success'">
                                <b-icon-check-circle-fill variant="success"></b-icon-check-circle-fill>
                            </div>
                        </b-col>
                    </b-row>
                </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
    import uploaderMixin from "@/api/uploader";

    export default {
        name: "Uploader",
        mixins: [ uploaderMixin ],
        data() {
            return {
                files: [],
                isUploading: false,
                uploads: {},
            }
        },
        methods: {
            clear() {
                this.files = [];
                this.uploads = {};
            },
            async upload() {
                this.isUploading = true;

                let promises = [];

                for (let i = 0; i < this.dirFiles.length; i++) {
                    this.$set(this.uploads, this.dirFiles[i].name, {msg: 'Uploading', status: 'busy'});

                    promises.push(this.doUploadFile(this.dirFiles[i], i));
                }

                try {
                    const results = await Promise.all(promises);
                    let uploads = [];

                    for (let i = 0; i < results.length; i++) {
                        if (results[i].msg === 'error') {
                            this.uploads[results[i].file.name] = { status: 'error', msg: results[i].error };
                        } else {
                            this.uploads[results[i].file.name] = { status: 'success' };
                            uploads.push(results[i].presign.fields.Key);
                        }
                    }

                    await this.linkMedia(uploads);
                } catch (error) {
                    console.log(error);
                }

                this.isUploading = false;
            },
            async doUploadFile(file, index) {
                try {
                    const presign = await this.getPresign(file.name, file.lastModified);

                    const upload = await this.uploadFile(presign, file);

                    return { msg: 'success', file: file, presign: presign, index: index, upload: upload };
                } catch (error) {
                    return { msg: 'error', file: file, index: index, error: error.message };
                }
            },
        },
        computed: {
            dirFiles() {
                let files = [];

                this.files.forEach(file => {
                   let f = file;

                   files.push(f);
                });

                return files;
            }
        },
        watch: {
            files(values) {
                console.log(values);
            }
        }
    }
</script>

<style scoped>

</style>